import type { Product, SectionProductDetail } from '@space-shell/common/services/sections'
import type { ProductModel } from '@space-shell/modules/sales/domain/product'
import type { Location } from 'react-router-dom'

import { formatPriceValue } from './productCoupon'

export const getSubscriptionPrice = (
  sectionProduct: Product | SectionProductDetail | ProductModel | undefined,
  locale: string
) => {
  if (!sectionProduct) {
    return {
      fullPrice: null
    }
  }

  const currencyCode = sectionProduct?.plan?.currencyValue?.currencyCode
  const couponDiscount = sectionProduct?.couponInfo?.discount
  const percentage = 100
  const productFullPrice =
    sectionProduct?.plan?.monthValue && currencyCode
      ? formatPriceValue({
          amount: {
            value: sectionProduct.plan.monthValue,
            currency: currencyCode
          },
          locale
        })
      : null
  const productCouponPrice =
    sectionProduct?.couponInfo?.monthValue && currencyCode
      ? formatPriceValue({
          amount: {
            value: sectionProduct.couponInfo.monthValue,
            currency: currencyCode
          },
          locale
        })
      : null
  const productCouponPercentage =
    couponDiscount && couponDiscount > 0 ? Math.round(couponDiscount * percentage) : 0

  return {
    fullPrice: productFullPrice,
    currency: currencyCode,
    discountedPrice: {
      fullPrice: productCouponPrice,
      coupon: productCouponPercentage
    }
  }
}

export const getSubscriptionPage = (location: Location) => {
  const queryString = location.search ? `${location.search}&` : `?`

  return `${location.pathname}${queryString}subscriptionPage=true`
}

export const getSubscriptionCoupon = (product: Product | SectionProductDetail) => {
  const PERCENTAGE = 100

  if (!product?.plan?.monthValue || !product?.couponInfo || !product?.couponInfo?.discount) {
    return 0
  }

  return product.couponInfo.discount > 0 ? Math.round(product.couponInfo.discount * PERCENTAGE) : 0
}

export const isSubscriptionPlan = (
  sectionProduct: Product | SectionProductDetail | ProductModel | undefined
) => {
  return !!sectionProduct?.plan?.id
}
